export default {
      id: "mir-lg-usage",
      viewBox: "0 0 400 120",
      url: __webpack_public_path__ + "svgsprite.svg#mir-lg",
      toString: function () {
        return this.url;
      }
    }